import { render, staticRenderFns } from "./CardContact.vue?vue&type=template&id=6b4a4cb5"
import script from "./CardContact.vue?vue&type=script&lang=js"
export * from "./CardContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4a4cb5')) {
      api.createRecord('6b4a4cb5', component.options)
    } else {
      api.reload('6b4a4cb5', component.options)
    }
    module.hot.accept("./CardContact.vue?vue&type=template&id=6b4a4cb5", function () {
      api.rerender('6b4a4cb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoInfo/CardContact.vue"
export default component.exports